import React, { useState } from 'react';
import { useFirebaseAuth } from '../auth/FirebaseAuthProvider';
import { useNavigate } from 'react-router-dom';
import './css/Login.css';

const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isSignUp, setIsSignUp] = useState(false);
  const { signInWithEmail, signInWithGoogle, isAuthenticated } = useFirebaseAuth();
  const navigate = useNavigate();

  React.useEffect(() => {
    if (isAuthenticated) {
      navigate('/home');
    }
  }, [isAuthenticated, navigate]);

  const handleEmailSignIn = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    try {
      await signInWithEmail(email, password);
      navigate('/home');
    } catch (err: any) {
      setError(err.message || 'Failed to sign in');
    }
  };

  const handleGoogleSignIn = async () => {
    setError('');
    try {
      await signInWithGoogle();
      navigate('/home');
    } catch (err: any) {
      setError(err.message || 'Failed to sign in with Google');
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-card-body">
          <h3 className="login-title">
            {isSignUp ? 'Sign Up' : 'Sign In'}
          </h3>

          {error && (
            <div className="login-alert" role="alert">
              <i className="fas fa-exclamation-circle me-2"></i>
              {error}
            </div>
          )}

          <form onSubmit={handleEmailSignIn}>
            <div className="login-form-group">
              <label className="login-form-label" htmlFor="formEmail">
                Email address
              </label>
              <input
                type="email"
                className="login-form-control form-control"
                id="formEmail"
                placeholder="Enter email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <div className="login-form-group">
              <label className="login-form-label" htmlFor="formPassword">
                Password
              </label>
              <input
                type="password"
                className="login-form-control form-control"
                id="formPassword"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            <button type="submit" className="login-btn-primary">
              <i className="fas fa-sign-in-alt me-2"></i>
              {isSignUp ? 'Sign Up' : 'Sign In'}
            </button>
          </form>

          <div className="login-divider">
            <span>or</span>
          </div>

          <button
            onClick={handleGoogleSignIn}
            className="login-btn-google"
          >
            <i className="fab fa-google"></i>
            Sign in with Google
          </button>

          <div className="login-toggle-link">
            <button
              onClick={() => setIsSignUp(!isSignUp)}
            >
              {isSignUp
                ? 'Already have an account? Sign In'
                : "Don't have an account? Sign Up"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
